"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const createIconSvg = (iconName, render) => {
  class IconSvg extends _react2.default.Component {

    render() {
      let { color } = this.props;
      if (color === "grey") {
        color = _styles.colors.greyIconSvg;
      } else if (color === "white") {
        color = _styles.colors.white;
      } else if (color === "blue") {
        color = "#5d69e6";
      }

      return render({
        color
      });
    }
  }

  IconSvg.propTypes = {
    color: _propTypes2.default.string
  };
  IconSvg.defaultProps = {
    color: _styles.colors.accentFocusInput
  };
  IconSvg.displayName = iconName;

  return IconSvg;
};

const AddO = createIconSvg("Add0", ({ color }) => _react2.default.createElement("path", {
  d: "M12 7c-.55 0-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z",
  fill: color
}));

const CheckO = createIconSvg("CheckO", ({ color }) => _react2.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.88-11.71L10 14.17l-1.88-1.88c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7c.39-.39.39-1.02 0-1.41-.39-.39-1.03-.39-1.42 0z",
  fill: color
}));

const CheckEmpty = createIconSvg("CheckEmpty", ({ color }) => _react2.default.createElement("path", {
  d: "M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm1-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z",
  fill: color
}));

const CheckSelected = createIconSvg("CheckSelected", ({ color }) => _react2.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8.29 13.29c-.39.39-1.02.39-1.41 0L5.71 12.7c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-7.58 7.59z",
  fill: color
}));

const Close = createIconSvg("Close", ({ color }) => _react2.default.createElement("path", {
  d: "M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z",
  fill: color
}));

const CreateNew = createIconSvg("CreateNew", ({ color }) => _react2.default.createElement("path", {
  d: "M14,2H6C4.9,2,4,2.9,4,4l0,16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8L14,2z M18,20H6V4h7v4c0,0.5,0.5,1,1,1h4V20z",
  fill: color
}));

const Download = createIconSvg("Download", ({ color }) => _react2.default.createElement("path", {
  d: "M16.6,10H15V5c0-0.6-0.4-1-1-1h-4C9.4,4,9,4.4,9,5v5H7.4c-0.9,0-1.3,1.1-0.7,1.7l4.6,4.6c0.4,0.4,1,0.4,1.4,0l4.6-4.6 C17.9,11.1,17.5,10,16.6,10z M5,20c0,0.5,0.4,1,1,1h12c0.5,0,1-0.5,1-1s-0.5-1-1-1H6C5.4,19,5,19.5,5,20z",
  fill: color
}));

const House = createIconSvg("House", ({ color }) => _react2.default.createElement("path", {
  d: "M10 19v-5h4v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-7h1.7c.46 0 .68-.57.33-.87L12.67 3.6c-.38-.34-.96-.34-1.34 0l-8.36 7.53c-.34.3-.13.87.33.87H5v7c0 .55.45 1 1 1h3c.55 0 1-.45 1-1z",
  fill: color
}));

const LeftArrow = createIconSvg("LeftArrow", ({ color }) => _react2.default.createElement("path", {
  d: "M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42-.39-.39-1.02-.39-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1z",
  fill: color
}));

const MinusO = createIconSvg("MinusO", ({ color }) => _react2.default.createElement("path", {
  d: "M7 12c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1zm5-10C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z",
  fill: color
}));

const RightArrow = createIconSvg("RightArrow", ({ color }) => _react2.default.createElement("path", {
  d: "M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41l-6.58-6.6c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1z",
  fill: color
}));

const Reload = createIconSvg("Reload", ({ color }) => _react2.default.createElement("path", {
  d: "M17.65 6.35c-1.63-1.63-3.94-2.57-6.48-2.31-3.67.37-6.69 3.35-7.1 7.02C3.52 15.91 7.27 20 12 20c3.19 0 5.93-1.87 7.21-4.56.32-.67-.16-1.44-.9-1.44-.37 0-.72.2-.88.53-1.13 2.43-3.84 3.97-6.8 3.31-2.22-.49-4.01-2.3-4.48-4.52C5.31 9.44 8.26 6 12 6c1.66 0 3.14.69 4.22 1.78l-1.51 1.51c-.63.63-.19 1.71.7 1.71H19c.55 0 1-.45 1-1V6.41c0-.89-1.08-1.34-1.71-.71l-.64.65z",
  fill: color
}));

const Applications = createIconSvg("Applications", ({ color }) => _react2.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm1 14H8c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1 .45 1 1s-.45 1-1 1zm3-4H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z",
  fill: color
}));

const Users = createIconSvg("Users", ({ color }) => _react2.default.createElement("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05.02.01.03.03.04.04 1.14.83 1.93 1.94 1.93 3.41V18c0 .35-.07.69-.18 1H22c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5z",
  fill: color
}));

const Companies = createIconSvg("Companies", ({ color }) => _react2.default.createElement("path", {
  d: "M12 7V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-8zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm9 12h-7v-2h2v-2h-2v-2h2v-2h-2V9h7c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1zm-1-8h-2v2h2v-2zm0 4h-2v2h2v-2z",
  fill: color
}));

const LeftArrowSidebar = createIconSvg("LeftArrowSidebar", ({ color }) => _react2.default.createElement("path", {
  d: "M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42-.39-.39-1.02-.39-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1z",
  fill: color
}));

const AudienceDiscovery = createIconSvg("AudienceDiscovery", ({ color }) => _react2.default.createElement("path", {
  d: "M12,22C6.5,22,2,17.5,2,12S6.5,2,12,2s10,4.5,10,10S17.5,22,12,22z M12,21c5,0,9-4,9-9s-4-9-9-9 s-9,4-9,9S7,21,12,21z M10.5,15.5l-0.5-1.4H7.3l-0.4,1.4H6l2.3-6.9h0.8l2.3,6.9H10.5z M9.8,13.4L8.7,9.6h0l-1.2,3.8H9.8z M13.6,14.7 h0.9c1.4,0,2.2-0.8,2.2-2.7c0-1.8-0.8-2.7-2.2-2.7h-1V14.7z M12.8,15.5V8.5h1.9c1.5,0,3,1.1,3,3.4c0,2.6-1.5,3.5-3,3.5H12.8z",
  fill: color
}));

const TVInsight = createIconSvg("TVInsight", ({ color }) => _react2.default.createElement("path", {
  d: "M12,22C6.5,22,2,17.5,2,12S6.5,2,12,2s10,4.5,10,10S17.5,22,12,22z M12,21c5,0,9-4,9-9s-4-9-9-9 s-9,4-9,9S7,21,12,21z M8.5,15.9v-6H6.2V9.1h5.3v0.7H9.3v6H8.5z M14.7,15.9l-2.2-6.7h0.9l1.8,5.7h0l1.7-5.7h0.9l-2.1,6.7H14.7z",
  fill: color
}));

const AccountSettings = createIconSvg("AccountSettings", ({ color }) => _react2.default.createElement("path", {
  d: "M16.6,13.9c0.4,0,0.6,0.3,0.6,0.6v1.7c0,0.4-0.3,0.6-0.6,0.6h-0.6c-0.1,0.4-0.3,0.9-0.5,1.3 l0.4,0.4c0.3,0.3,0.3,0.7,0,0.9l-1.2,1.2c-0.3,0.3-0.7,0.3-0.9,0l-0.4-0.4c-0.4,0.2-0.8,0.4-1.3,0.5v0.6c0,0.4-0.3,0.6-0.6,0.6H9.7 c-0.4,0-0.6-0.3-0.6-0.6v-0.6c-0.4-0.1-0.9-0.3-1.3-0.5l-0.4,0.4c-0.3,0.3-0.7,0.3-0.9,0l-1.2-1.2c-0.3-0.3-0.3-0.7,0-0.9l0.4-0.4 c-0.2-0.4-0.4-0.8-0.5-1.3H4.5c-0.4,0-0.6-0.3-0.6-0.6v-1.7c0-0.4,0.3-0.6,0.6-0.6h0.6c0.1-0.4,0.3-0.9,0.5-1.3l-0.4-0.4 c-0.3-0.3-0.3-0.7,0-0.9L6.4,10c0.3-0.3,0.7-0.3,0.9,0l0.4,0.4c0.4-0.2,0.8-0.4,1.3-0.5l0-0.6c0-0.4,0.3-0.6,0.6-0.6h1.7 C11.8,8.7,12,9,12,9.3V10c0.4,0.1,0.9,0.3,1.3,0.5l0.4-0.4c0.3-0.3,0.7-0.3,0.9,0l1.2,1.2c0.3,0.3,0.3,0.7,0,0.9l-0.4,0.4 c0.2,0.4,0.4,0.8,0.5,1.3H16.6z M10.5,18.3c1.6,0,3-1.3,3-3c0-1.6-1.3-3-3-3c-1.6,0-3,1.3-3,3C7.6,17,8.9,18.3,10.5,18.3z M18.1,4.7 l0.2,1.1c0,0.2-0.1,0.4-0.3,0.4l-0.5,0.1c-0.1,0.4-0.2,0.8-0.4,1.1l0.3,0.4c0.1,0.2,0.1,0.4-0.1,0.5l-0.8,0.7 c-0.1,0.1-0.4,0.1-0.5,0l-0.4-0.4c-0.4,0.1-0.8,0.2-1.2,0.2L14,9.3c-0.1,0.2-0.3,0.3-0.5,0.2l-1-0.4c-0.2-0.1-0.3-0.3-0.2-0.5 l0.1-0.5C12.3,8,12.1,7.8,12,7.7c-0.1-0.2-0.2-0.3-0.3-0.5l-0.5,0c-0.2,0-0.4-0.1-0.4-0.3l-0.2-1.1c0-0.2,0.1-0.4,0.3-0.4l0.5-0.1 c0.1-0.4,0.2-0.8,0.4-1.1l-0.3-0.4c-0.1-0.2-0.1-0.4,0.1-0.5l0.8-0.7c0.1-0.1,0.4-0.1,0.5,0l0.4,0.4c0.4-0.1,0.8-0.2,1.2-0.2 l0.2-0.5C14.9,2,15.1,2,15.3,2l1,0.4c0.2,0.1,0.3,0.3,0.2,0.5l-0.1,0.5c0.1,0.1,0.3,0.3,0.4,0.4C16.9,4,17,4.2,17.1,4.4l0.5,0 C17.9,4.3,18,4.5,18.1,4.7z M15.4,7.1c0.7-0.6,0.9-1.7,0.3-2.4c-0.6-0.7-1.6-0.9-2.4-0.3c-0.7,0.6-0.9,1.6-0.3,2.4 C13.6,7.6,14.7,7.7,15.4,7.1z",
  fill: color
}));

const QuantifyReports = createIconSvg("QuantifyReports", ({ color }) => _react2.default.createElement("path", {
  d: "M12,22C6.5,22,2,17.5,2,12S6.5,2,12,2s10,4.5,10,10S17.5,22,12,22z M12,21c5,0,9-4,9-9s-4-9-9-9s-9,4-9,9 S7,21,12,21z M8.6,15.3c-1.3,0-2.5-1-2.5-3.6c0-2.3,1.3-3.5,2.5-3.5s2.5,1.2,2.5,3.5c0,1-0.2,1.8-0.6,2.4l0.7,0.7l-0.5,0.4l-0.7-0.6 C9.8,15.1,9.1,15.3,8.6,15.3z M8.6,14.5c0.4,0,0.7-0.1,1-0.4L8,12.5L8.4,12l1.5,1.5c0.2-0.4,0.3-1,0.3-1.8C10.2,9.9,9.6,9,8.6,9 s-1.7,0.8-1.7,2.7C6.9,13.6,7.6,14.5,8.6,14.5z M17.3,12.1l0.6,0.6l-2.7,2.7l-2.8-2.8l0.6-0.6l1.7,1.7v-5h0.8v5.1L17.3,12.1z M12.9,16h4.4v0.8h-4.4V16z",
  fill: color
}));

const DownCaret = createIconSvg("DownCaret", ({ color }) => _react2.default.createElement("path", {
  d: "M17.3,10c-0.4-0.4-1-0.4-1.4,0L12,13.9L8.1,10c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l4.6,4.6c0.4,0.4,1,0.4,1.4,0 l4.6-4.6C17.7,11,17.7,10.4,17.3,10z",
  fill: color
}));

const RightCaret = createIconSvg("RightCaret", ({ color }) => _react2.default.createElement("path", {
  d: "M9.29 6.71c-.39.39-.39 1.02 0 1.41L13.17 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z",
  fill: color
}));

const HistoricalTrending = createIconSvg("HistoricalTrending", ({ color }) => _react2.default.createElement("path", {
  d: "M12,22C6.5,22,2,17.5,2,12S6.5,2,12,2s10,4.5,10,10S17.5,22,12,22z M12,21c5,0,9-4,9-9s-4-9-9-9s-9,4-9,9S7,21,12,21z M7.5,9.1V12H11V9.1h0.9v6.8H11v-3.1H7.5v3.1H6.6V9.1H7.5z M12.7,9.9V9.1h5.4v0.8h-2.3v6H15v-6H12.7z",
  fill: color
}));

const OptInDashboard = createIconSvg("OptInDashboard", ({ color }) => _react2.default.createElement("path", {
  d: "M12,22C6.5,22,2,17.5,2,12S6.5,2,12,2s10,4.5,10,10S17.5,22,12,22z M12,21c5,0,9-4,9-9s-4-9-9-9s-9,4-9,9S7,21,12,21z M7.4,11c0.1-0.4,0.3-0.8,0.6-1.1c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.4-0.3s1,0.1,1.4,0.3c0.4,0.2,0.8,0.5,1,0.8 c0.3,0.3,0.5,0.7,0.6,1.1c0.1,0.4,0.2,0.9,0.2,1.3s-0.1,0.9-0.2,1.3c-0.1,0.4-0.3,0.8-0.6,1.1c-0.3,0.3-0.6,0.6-1,0.8 c-0.4,0.2-0.9,0.3-1.4,0.3s-1-0.1-1.4-0.3c-0.4-0.2-0.8-0.5-1-0.8c-0.3-0.3-0.5-0.7-0.6-1.1c-0.1-0.4-0.2-0.9-0.2-1.3 S7.3,11.5,7.4,11z M8.3,13.4c0.1,0.3,0.2,0.6,0.4,0.9s0.4,0.5,0.7,0.6s0.7,0.2,1.1,0.2s0.8-0.1,1.1-0.2s0.5-0.4,0.7-0.6 s0.3-0.6,0.4-0.9c0.1-0.3,0.1-0.7,0.1-1s0-0.7-0.1-1c-0.1-0.3-0.2-0.6-0.4-0.9c-0.2-0.3-0.4-0.5-0.7-0.6s-0.7-0.2-1.1-0.2 S9.8,9.6,9.5,9.8s-0.5,0.4-0.7,0.6c-0.2,0.3-0.3,0.6-0.4,0.9s-0.1,0.7-0.1,1S8.2,13.1,8.3,13.4z M16.1,9v6.9h-0.9V9H16.1z",
  fill: color
}));

const iconMap = {
  "add-o": AddO,
  "check-empty": CheckEmpty,
  "check-selected": CheckSelected,
  "check-o": CheckO,
  close: Close,
  download: Download,
  home: House,
  house: House,
  "left-arrow": LeftArrow,
  "minus-o": MinusO,
  new: CreateNew,
  "right-arrow": RightArrow,
  reload: Reload,
  applications: Applications,
  users: Users,
  companies: Companies,
  "left-arrow-sidebar": LeftArrowSidebar,
  "down-caret": DownCaret,
  "right-caret": RightCaret,
  "audience-discovery": AudienceDiscovery,
  "tv-insights": TVInsight,
  "account-settings": AccountSettings,
  "company-manager": AccountSettings,
  "quantify-reports": QuantifyReports,
  "historical-trending": HistoricalTrending,
  "opt-in-dashboard": OptInDashboard
};

const StyledSVG = _styledComponents2.default.svg.withConfig({
  displayName: "IconSvg__StyledSVG",
  componentId: "sc-1j8llz3-0"
})(["height:", "px;width:", "px;"], p => p.width ? p.width : "20", p => p.width ? p.width : "20");

const IconSvg = (_ref) => {
  let { name } = _ref,
      props = _objectWithoutProperties(_ref, ["name"]);

  const MappedIcon = iconMap[name];
  if (MappedIcon) {
    return _react2.default.createElement(
      StyledSVG,
      _extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }, props),
      _react2.default.createElement(MappedIcon, props)
    );
  }

  return _react2.default.createElement("div", null);
};

IconSvg.propTypes = {
  className: _propTypes2.default.string,

  /**
   * Name of svg
   */
  name: _propTypes2.default.string,
  color: _propTypes2.default.oneOf(["blue", "grey", "white"])
};

exports.default = IconSvg;